import {
  MenuItem,
  MenuQuickAction,
} from '../../../../ui-components/lib/sidenav/sidenav.model';

/** Figma's ＋ rows: Workflows (new request) and Resources (add a resource). Absent = no ＋. */
export interface EmployeeSideMenuQuickActions {
  requests?: MenuQuickAction;
  resources?: MenuQuickAction;
}

/**
 * KUIP-68 employee menu: arranges the already-filtered flat employee items (role, modules,
 * corporate-finance flag) into sections. Items missing from `items` are skipped; empty groups dropped.
 */
export function buildEmployeeSideMenuSections(
  items: MenuItem[],
  translate: (key: string) => string,
  quickActions: EmployeeSideMenuQuickActions = {}
): MenuItem[][] {
  const byId = new Map(items.map(item => [item.id, item]));
  const pick = (...ids: string[]) =>
    ids.map(id => byId.get(id)).filter((item): item is MenuItem => !!item);
  const group = (
    id: string,
    labelKey: string,
    ids: string[],
    quickAction?: MenuQuickAction
  ): MenuItem[] => {
    const children = pick(...ids);
    return children.length
      ? [
          {
            id,
            label: translate(labelKey),
            path: '',
            children,
            quickAction,
            expanded: true,
          },
        ]
      : [];
  };
  const requests = byId.get('requests');

  return [
    pick('home', 'inbox', 'businessCalendar'),
    requests
      ? [
          {
            ...requests,
            label: translate('sidenav_workflows_item_label'),
            quickAction: quickActions.requests,
            ruleBefore: true,
          },
        ]
      : [],
    group(
      'resources',
      'sidenav_group_resources_label',
      ['project', 'vendors', 'invoice'],
      quickActions.resources
    ),
    pick('corporateFinance')
      .filter(item => !!item.children?.length)
      .map(item => ({ ...item, expanded: true })),
    group('company', 'sidenav_group_company_label', [
      'team',
      'organization',
      'organizationsHierarchy',
    ]),
  ].filter(section => section.length > 0);
}
